export const RuI18n = {
  Id: 'ÐÐ´.',
  Title: 'ÐÐ°Ð³Ð¾Ð»Ð¾Ð²Ð¾Ðº',
  Description: 'ÐÐ¿Ð¸ÑÐ°Ð½Ð¸Ðµ',
  'Is public': 'ÐÑÐ±Ð»Ð¸ÑÐ½ÑÐ¹',
  'Created at': 'ÐÐ°ÑÐ° ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ',
  'Updated at': 'ÐÐ°ÑÐ° Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ',
  Statuses: 'Ð¡ÑÐ°ÑÑÑÑ',
  Tasks: 'ÐÐ°Ð´Ð°ÑÐ¸',
  Users: 'ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ð¸',
  'Completed tasks': 'ÐÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð½ÑÐµ Ð·Ð°Ð´Ð°ÑÐ¸',
  'Add new project': 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð¿ÑÐ¾ÐµÐºÑ',
  'Project #{{id}}': 'ÐÑÐ¾ÐµÐºÑÐ° #{{id}}',
  'Update project #{{id}}': 'Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð¿ÑÐ¾ÐµÐºÑÐ° #{{id}}',
  'Delete project #{{id}}': 'Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð¿ÑÐ¾ÐµÐºÑ  #{{id}}',
  'Do you really want to delete project?': 'ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ ÑÐ´Ð°Ð»Ð¸ÑÑ ÑÑÐ¾Ñ Ð¿ÑÐ¾ÐµÐºÑ?',
  Yes: 'ÐÐ°',
  No: 'ÐÐµÑ',
  Project: 'ÐÑÐ¾ÐµÐºÑ',
  Name: 'ÐÐ°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ',
  'Add new status': 'Ð¡Ð¾Ð·Ð´Ð°Ð½Ð¸Ðµ Ð½Ð¾Ð²Ð¾Ð³Ð¾ ÑÑÐ°ÑÑÑÐ°',
  'Status #{{id}}': 'Ð¡ÑÐ°ÑÑÑ #{{id}}',
  'Update status #{{id}}': 'ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ ÑÑÐ°ÑÑÑ #{{id}}',
  'Delete status #{{id}}': 'Ð£Ð´Ð°Ð»Ð¸ÑÑ ÑÑÐ°ÑÑÑ  #{{id}}',
  'Do you really want to delete status?': 'ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ ÑÐ´Ð°Ð»Ð¸ÑÑ ÑÑÐ°ÑÑÑ?',
  Status: 'Ð¡ÑÐ°ÑÑÑ',
  'Open at': 'ÐÐ°ÑÐ° Ð¾ÑÐºÑÑÑÐ¸Ñ',
  'Close at': 'ÐÐ°ÑÐ° Ð·Ð°ÐºÑÑÑÐ¸Ñ',
  'Task time': 'ÐÑÐµÐ¼Ñ Ð·Ð°Ð´Ð°ÑÐ¸',
  'Created user': 'Ð¡Ð¾Ð·Ð´Ð°Ð»',
  'Updated user': 'ÐÐ±Ð½Ð¾Ð²Ð¸Ð»',
  'Assigned user': 'ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ',
  'Add new task': 'Ð¡Ð¾Ð·Ð´Ð°Ð½Ð¸Ðµ Ð½Ð¾Ð²Ð¾Ð¹ Ð·Ð°Ð´Ð°ÑÐ¸',
  'Task #{{id}}': 'ÐÐ°Ð´Ð°ÑÐ° #{{id}}',
  'Update task #{{id}}': 'ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ Ð·Ð°Ð´Ð°ÑÑ  #{{id}}',
  'Delete task #{{id}}': 'Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð·Ð°Ð´Ð°ÑÑ  #{{id}}',
  'Do you really want to delete task?': 'ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ ÑÐ´Ð°Ð»Ð¸ÑÑ Ð·Ð°Ð´Ð°ÑÑ?',
  Russian: 'Ð ÑÑÑÐºÐ¸Ð¹',
  English: 'ÐÐ½Ð³Ð»Ð¸Ð¹ÑÐºÐ¸Ð¹'
};
